export const ACCEPTED_FILE_TYPES = [
  'image/*',
  'audio/*',
  'video/*',
  'application/octet-stream',
  'text/csv',
  'text/plain',
  'application/json',
  'application/pdf',
  'application/vnd.oasis.opendocument.text',
  'application/msword',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/x-iwork-pages-sffpages',
  'application/x-iwork-keynote-sffkey',
  'application/x-iwork-numbers-sffnumbers',
  'application/vnd.apple.pages',
  'application/vnd.apple.keynote',
  'application/vnd.apple.numbers',
  'application/rtf',
  'application/gzip',
  'application/x-gzip',
  'application/x-7z-compressed',
  'application/zip',
];

export const FILE_TYPE_BY_EXTENSION = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  odt: 'application/vnd.oasis.opendocument.text',
  rtf: 'application/rtf',
  txt: 'text/plain',
  csv: 'text/csv',
  json: 'application/json',
  pages: 'application/vnd.apple.pages',
  key: 'application/vnd.apple.keynote',
  numbers: 'application/vnd.apple.numbers',
  zip: 'application/zip',
  gz: 'application/gzip',
  '7z': 'application/x-7z-compressed',
};

export const UNKNOWN_FILE_TYPE = 'application/octet-stream';

export function fileExtension(filename) {
  return String(filename || '').split('.').pop().toLowerCase();
}

export function fileTypeFromExtension(filename) {
  return FILE_TYPE_BY_EXTENSION[fileExtension(filename)];
}

export const detectFileType = (file, type) => {
  const name = typeof file === 'string' ? file : file && file.name;
  return Promise.resolve(fileTypeFromExtension(name) || type || UNKNOWN_FILE_TYPE);
};

export const MIN_FILE_SIZE = 1;

export function fileValidationOptions({
  notAllowedLabel, expectedTypesLabel, emptyLabel, emptyHintLabel,
} = {}) {
  const options = {
    acceptedFileTypes: ACCEPTED_FILE_TYPES,
    fileValidateTypeDetectType: detectFileType,
    allowSyncAcceptAttribute: false,
    minFileSize: MIN_FILE_SIZE,
  };

  if (notAllowedLabel) options.labelFileTypeNotAllowed = notAllowedLabel;
  if (expectedTypesLabel) options.fileValidateTypeLabelExpectedTypes = expectedTypesLabel;
  if (emptyLabel) options.labelMinFileSizeExceeded = emptyLabel;
  if (emptyHintLabel) options.labelMinFileSize = emptyHintLabel;

  return options;
}
